<template>
    <main-content-wrapper>
        <h1 class="text-md-center">Včlanitev v Tuš klub</h1>
        <v-alert
                :value="registration_problem"
                type="error"
        >
            {{ registration_problem_msg }}
        </v-alert>
        <empty-space v-if="registration_problem" />
        <split-content text="Prijavni podatki" />
        <empty-space />
        <v-form v-model="valid" @submit.prevent="" ref="form">
            <v-flex xs12 class="pa-2" v-if="!authenticated">
                <email-field v-model="email" label="Vpišite vaš e-naslov" :error-messages="email_error_messages" :rules="[checkEmail]" ref="email_input" required autofocus />
                <p class="caption">
                    Vnos elektronske pošte pri spletni včlanitvi je obvezen zaradi potrditve včlanitve preko elektronske pošte, ki nadomesti lastnoročni podpis.</p>

                <p class="caption">
                    Ta podatek se bo uporabljal za neposredno obveščanje o ugodnostih, aktivnostih, storitvah in dogodkih podjetja. Od obveščanja se lahko po prejetem e-obvestilu odjavite. V kolikor ne želite podati svojega e-naslova, se lahko včlanite v Tuš klub v katerikoli poslovalnici s tiskanim pristopnim obrazcem za včlanitev v Tuš klub.
                </p>
                <p class="caption">
                    <b>Z vpisanim e-naslovom in geslom, ki si ga boste določili, se boste lahko po uspešni včlanitvi prijavili v spletni Tuš klub profil.</b>
                </p>
                <password-field label="Izberite geslo" v-model="password" :rules="newPasswordRules" />
                <password-field label="Ponovno vpišite geslo" v-model="password_again" :rules="[checkNewPasswordAgain]" />
            </v-flex>
            <v-flex xs12 class="pa-2" v-if="authenticated">
                <p class="text-md-center">V spletni račun ste že prijavljeni kot</p>
                <h2 class="text-md-center">{{ authenticated_user.email }}</h2>
                <empty-space />
            </v-flex>
            <split-content text="Privolitve in načini obveščanja" />
            <empty-space />
            <v-flex xs12 class="pa-2">
                <v-checkbox
                        v-model="confirm_all_consents"
                        color="primary"
                        required
                >
                    <div slot="label">
                        Strinjam se z vsemi spodaj opredeljenimi nameni obdelovanja osebnih podatkov ter kanali obveščanja.
                    </div>
                </v-checkbox>
                <v-alert
                        :value="confirm_cond_error"
                        type="error"
                >
                    Za nadaljevanje se je potrebno strinjati s pogoji uporabe.
                </v-alert>
                <v-checkbox
                        v-model="confirm_cond"
                        color="primary"
                        required
                >
                    <div slot="label">
                        Potrjujem, da sem prebral/a <a target="_blank"  v-on:click.stop="" href="https://www.tus.si/o-tus-klub-kartici/splosni-pogoji-tus-klub/" class="terms">splošne pogoje poslovanja</a> Tuš kluba ter jih razumem in se z njimi strinjam.
                    </div>
                </v-checkbox>
            </v-flex>
        </v-form>

        <v-btn to="/ustvari/vclanitev/korak3" :loading="loading" depressed large block color="primary_action" @click="registerAccount">POTRDI</v-btn>
        <v-layout justify-center row wrap>
            <v-flex xs12 sm6 class="pa-2">
                <v-btn class="consents-toggle" text @click="show_consents=!show_consents"><v-icon v-if="!show_consents">fas fa-angle-down</v-icon><v-icon v-if="show_consents">fas fa-angle-up</v-icon> Posamezne privolitve</v-btn>
                <consents v-if="show_consents" vuex_module="registration" />
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
                <v-btn class="consents-toggle" text @click="show_consents_channels=!show_consents_channels"><v-icon v-if="!show_consents_channels">fas fa-angle-down</v-icon><v-icon v-if="show_consents_channels">fas fa-angle-up</v-icon> Kanali za obveščanje</v-btn>
                <consents-channels v-if="show_consents_channels" vuex_module="registration" />
            </v-flex>
        </v-layout>

    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import SplitContent from "../components/SplitContent";
    import EmptySpace from "../components/EmptySpace";
    import EmailField from "../components/EmailField";
    import PasswordField from "../components/PasswordField";
    import Consents from "../components/Consents";
    import ConsentsChannels from "../components/ConsentsChannels";
    import utils from "../store/utils";
    import validations from "../components/validations";
    import Router from '../router';
    import {userService} from "../services";

    export default {
        name: "JoinClubAccount",
        components: {MainContentWrapper, ConsentsChannels, Consents, SplitContent, EmptySpace, EmailField, PasswordField},
        data: vm => ({
            show_consents: false,
            show_consents_channels: false,
            newPasswordRules: validations.newPasswordRules,
            email_error_messages: [],
            confirm_cond_error: false,
        }),
        computed: {
            authenticated: utils.vuexBuildSetGet(this, 'auth', 'authenticated'),
            authenticated_user: utils.vuexBuildSetGet(this, 'auth', 'authenticated_user'),
            email: utils.vuexBuildSetGet(this, 'registration', 'account.email'),
            password: utils.vuexBuildSetGet(this, 'registration', 'account.password'),
            password_again: utils.vuexBuildSetGet(this, 'registration', 'account.password_again'),
            confirm_cond: utils.vuexBuildSetGet(this, 'registration', 'account.confirm_cond'),
            confirm_all_consents: utils.vuexBuildSetGet(this, 'registration', 'confirm_all_consents', 'registration/confirmAllConsents'),
            loading: utils.vuexBuildSetGet(this, 'registration', 'loading'),
            registration_problem: utils.vuexBuildSetGet(this, 'registration', 'registration_problem'),
            registration_problem_msg: utils.vuexBuildSetGet(this, 'registration', 'registration_problem_msg')
        },
        created(){
            let canDo = this.$store.state.application.allow_join_club;
            if (!canDo){
                if (this.$store.state.application.allow_upgrade_to_club &&
                    this.$store.state.auth.authenticated_user.can_upgrade_join &&
                    this.$store.state.application.flow_data.request_type == 'UPG_JOIN'){
                    canDo = true;
                }
            }
            if (canDo){
                this.$store.dispatch('registration/checkStep', 3);
            } else {
                Router.push('/ustvari/');
            }
        },
        mounted() {
            this.$trackPageVisit('join-club-account');
        },
        methods: {
            registerAccount(){
                this.confirm_cond_error = false;
                this.$store.commit('registration/setRegistrationProblem', null);
                let isValid = this.$refs.form.validate();
                if (isValid) {
                    if (this.confirm_cond == false){
                        this.confirm_cond_error = true;
                        return;
                    }
                    this.$store.dispatch('registration/joinClub', {});
                }
            },
            checkNewPasswordAgain(v) {
                return validations.newPasswordCheckAgain(v, this.password);
            },
            checkEmail(v){
                this.email_error_messages = [];
                let noError = validations.checkEmailAll(v);
                if (noError === true){
                    if (this.$refs['email_input'].hasError == false) {
                        userService.checkEmail(v).then(
                            data => {

                            },
                            error => {
                                if (error.message) {
                                    this.email_error_messages = [error.message];
                                } else {
                                    this.email_error_messages = ['Napaka pri preverjanju naslova.'];
                                }
                            }
                        );
                    }
                    return true;
                }
                return noError;
            }
        }
    }
</script>

<style scoped>

    .consents-toggle {
        margin-left: 0px;
        padding-left: 0px;
    }

    .consents-toggle .v-icon {
        margin-right: 10px;
    }


</style>